//@flow

import React from 'react';
import { Collapse, Navbar, NavbarToggler, Nav } from 'reactstrap';

import config from '../../config';
import Toggler from '../UI/Toggler';
import makeUrl from '../../lib/makeUrl';
import CustomLink from './Link';
import UserDropdown from './UserDropdown';
import FlightsDropdown from './FlightsDropdown';

// import HG_logo from './assets/logo.png';
// import MainSearcPh from "./MainSearch";

const navBarLogo = `${config.ASSETS_URL}/navbar_logo.png`;

type Props = {
  userInfo: Object,
  logout: () => void,
  openLoginModal: () => void,
  openSignUpModal: () => void,
  history: Object,
};

export default function TopBarDesktop(props: Props) {
  const { userInfo } = props;
  const isUserLoggedIn = userInfo && Boolean(userInfo.userId);
  const { goToGuideListings, goToTreks, goToLodge, goToTransportation, goToBlog } = makeUrl;

  return (
    <Toggler>
      {({ on, toggle }) => (
        <Navbar color="faded" light expand="md" className="bg-white fix-padding">
          <div className="container">
            <a href="/" className="navbar-brand">
              <img src={navBarLogo} alt="HoneyGuide Logo" />
            </a>
            {/* <MainSearch /> */}
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={on} navbar>
              <Nav className="ml-auto menu-list" navbar>
                <CustomLink
                  linkTo={goToTreks}
                  linkIcon="tour.svg"
                  title="Tours"
                />
                <FlightsDropdown />
                <CustomLink
                  linkTo={goToLodge}
                  linkIcon="lodge.svg"
                  title="Lodges"
                />
                <CustomLink
                  useAnchor
                  linkTo={goToGuideListings}
                  linkIcon="guide.svg"
                  title="Guides"
                />
                <CustomLink
                  linkTo={goToTransportation}
                  linkIcon="transport.svg"
                  title="Transport"
                />
                <CustomLink
                  linkTo={goToBlog}
                  linkIcon="blog.svg"
                  title="Blog"
                  useAnchor
                />

                {isUserLoggedIn ? (
                  <UserDropdown {...props} isUserLoggedIn={isUserLoggedIn} />
                ) : (
                  null
                    // <Fragment>
                    //   <Button color="none" onClick={openLoginModal}>
                    //     Log in
                    // </Button>
                    //   <Button color="none" onClick={openSignUpModal}>
                    //     Sign Up
                    // </Button>
                    // </Fragment>
                  )}
              </Nav>
            </Collapse>
          </div>
        </Navbar>
      )}
    </Toggler>
  );
}



// WEBPACK FOOTER //
// ./src/components/TopBar/NavbarDesktop.jsx